import {NgModule,Injector} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import {ProductCardComponent} from "./product-card.component";
import {AddToCartModule} from '@signature-it/ngx-catalogue/components/add-to-cart';
import {ProductSolrImageDirectiveModule} from '@signature-it/ngx-catalogue/directives';
import {PriceModule_Catalogue} from '@signature-it/ngx-catalogue/components/price';
import {InventoryModule} from '@signature-it/ngx-catalogue/components/inventory';
import {AddToFavoriteModule_Generic} from "@signature-it/ngx-catalogue/components/favorites";
import {AddToCompareModule_Generic} from '@signature-it/ngx-catalogue/components/add-to-compare';
import {ReplaceTokensPipeArrayModule, SafePipeModule } from '@signature-it/ngx-generic/pipes';
import {ProdPicModule} from '@signature-it/ngx-catalogue/components/prod-pic';
import { OverlayImageModule } from '@signature-it/ngx-generic/components/overlay-image';
import { ContextFieldsModule } from '@signature-it/ngx-catalogue/components/context-fields';
import { createCustomElement } from "@angular/elements";

@NgModule({
    declarations: [
        ProductCardComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        AddToCartModule,
        NgbModule,
        ProductSolrImageDirectiveModule,
        MatSlideToggleModule,
        PriceModule_Catalogue,
        AddToFavoriteModule_Generic,
        AddToCompareModule_Generic,
        ProdPicModule,
        InventoryModule,
        ReplaceTokensPipeArrayModule,
        SafePipeModule,
        OverlayImageModule,
        ContextFieldsModule
    ],
    exports: [ProductCardComponent]
})
export class ProductCardModule_Catalogue {
    constructor(private injector: Injector) {
        const ProductCardComp = createCustomElement(ProductCardComponent, {injector});
        !customElements.get('ngx-product-card') && customElements.define('ngx-product-card', ProductCardComp);
    }
}
